import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Checkbox, FormGroup, FormControlLabel, makeStyles, Tooltip } from '@material-ui/core';
import map from 'lodash/map';

import { getI18n } from "../../../utils/intl";
import styles from './styles';

const MultiSelectMenu = (props) => {
  const { data, handleOnSelect, renderLabel, selectedData, showSecondaryText, disabled } = props;
  const intl = getI18n(useIntl());
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const customLabel = ({
    name,
    secondaryName,
    secondaryTooltip,
  }) => (
    <div>
      <div className={classes.customLabelItem} title={name}>
        <Tooltip
          arrow
          placement={'top'}
          title={name}
        >
          <span>{name}</span>
        </Tooltip>
      </div>
      <div className={classes.customLabelItem} title={secondaryName}>
        <Tooltip
          arrow
          placement={'top'}
          title={secondaryTooltip}
        >
          <span>{secondaryName}</span>
        </Tooltip>
      </div>
    </div>
  );
  const renderMenuItem = (item) => {
    const label = showSecondaryText ? customLabel(item) :
      (renderLabel ? renderLabel(item) : item.name);
    return (
      <FormControlLabel
        classes={{
          label: classes.customLabel,
        }}
        control={
          <Checkbox
            checked={!!selectedData[item.value]}
            className={classes.checkBox}
            disabled={disabled}
            name={item.name}
            onChange={(evt, checked) => handleOnSelect(item.value, checked)}
          />}
        label={label}
      />);
  };
  const renderMenu = () => {
    return (<FormGroup>
      {map(data, renderMenuItem)}
    </FormGroup>);
  };
  return (
    <div className={classes.root}>
      { data.length ?
        renderMenu() :
        <div className={classes.message}>
          {intl.getI18nMessage('label.analytics.dashboard.noData.text')}
        </div>
      }
    </div>);
};

MultiSelectMenu.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.array,
  selectedData: PropTypes.object,
  handleOnSelect: PropTypes.func,
  renderLabel: PropTypes.func,
  showSecondaryText: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default MultiSelectMenu;
